module.exports = __webpack_public_path__ + "img/navBar2@2x.7fe4b57b.png";